export const UMO_SORT_UMO_REQUEST = 'UMO_SORT_UMO_REQUEST';
export const UMO_SORT_UMO_SUCCESS = 'UMO_SORT_UMO_SUCCESS';
export const UMO_SORT_UMO_FAILURE = 'UMO_SORT_UMO_FAILURE';

export const ADD_TO_SORT_LIGHTBOX_REQUEST = 'ADD_TO_SORT_LIGHTBOX_REQUEST';
export const ADD_TO_SORT_LIGHTBOX_SUCCESS = 'ADD_TO_SORT_LIGHTBOX_SUCCESS';
export const ADD_TO_SORT_LIGHTBOX_FAILURE = 'ADD_TO_SORT_LIGHTBOX_FAILURE';



// WEBPACK FOOTER //
// ./src/js/actions/umoSortActionTypes.js